<template>
    <div
        class="toasts"
        v-if="state.toasts.length"
    >
        <div
            v-for="toast in state.toasts"
            :key="toast.id"
        >
            <ToastMessage :toast="toast" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { state } from '@/utils/state';
import ToastMessage from './ToastMessage.vue';
</script>
<style>
.toasts {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    right: 1rem;
    top: 1rem;
    z-index: 9999;
}
</style>
